(() => {
  const dialog = document.getElementById('hx-black-friday');
  if (!dialog) return;
  const start = Number(dialog.dataset.start);
  const end = Number(dialog.dataset.end);
  const preview = dialog.dataset.preview === 'true';
  const storageKey = 'hexamedic-bf-three-offers-2026';
  const eligible = () => Date.now() >= start && Date.now() < end;
  let opener;
  let shown = false;
  const updatePrices = () => {
    const active = eligible();
    document.querySelectorAll('[data-hx-bf-price]').forEach(el => {
      el.querySelector('[data-hx-bf-regular]').hidden = active;
      el.querySelector('[data-hx-bf-offer]').hidden = !active;
    });
    if (!active && !preview && dialog.open) dialog.close();
  };
  const close = () => {
    dialog.close();
    try { sessionStorage.setItem(storageKey, 'dismissed'); } catch (_) {}
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  };
  const maybeShow = () => {
    updatePrices();
    if (shown || (!eligible() && !preview) || dialog.dataset.available !== 'true') return;
    if (/^\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname)) return;
    try { if (!preview && sessionStorage.getItem(storageKey)) return; } catch (_) {}
    if (document.querySelector('dialog[open]')) return;
    if (typeof dialog.showModal !== 'function') return;
    opener = document.activeElement;
    shown = true;
    dialog.showModal();
    try { sessionStorage.setItem(storageKey, 'shown'); } catch (_) {}
  };
  dialog.querySelector('.hx-bf__close').addEventListener('click', close);
  dialog.querySelector('.hx-bf__later').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  updatePrices();
  setTimeout(maybeShow, 1800);
  setInterval(maybeShow, 60000);
  document.addEventListener('shopify:section:load', updatePrices);
})();